const { usePreview } = require('react-dnd-preview');

export default function GamePrintingMovableTypePreview() {
  const { display, style, item } = usePreview()
  if (!display) {
    return null
  }

  return <div className="game-printing-movable-type-preview" style={style}>
    <div className={`game-printing-movable-type game-printing-movable-type-${1 + item.progressIndex}-${1 + item.imgIndex} static`}>
      <div className={`movable-type-character ${item.text.match(/^[\u0000-\u007f]*$/) ? 'en' : 'zh'}`}>
        <div><div className="shadow">{item.text}</div><div className="offset">{item.text}</div><div className="text">{item.text}</div></div>
      </div>
    </div>
  </div>
}
